import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/Header";
import { useSearchParams } from "react-router-dom";

function DigitalConnectPricing() {
  const [searchParams] = useSearchParams();
  const firstName = searchParams.get("first_name");
  const title = firstName ? `Great talking with you, ${firstName}` : "Great talking with you";

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Our Blog" },
    { to: "/get-in-touch", label: "Support" },
  ];

  return (
    <>
      <Helmet>
        <title>{title} | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <style>
        {`
        .popular-badge {
            background-color: #00ABE4; /* DataPulse Cyan */
            color: #FFFFFF;
            font-size: 0.7rem;
            font-weight: 700;
            padding: 0.25rem 0.75rem;
            border-radius: 0 0 0 0.375rem; /* Rounded bottom-left */
            position: absolute;
            top: 0;
            right: 0;
            text-transform: uppercase;
        }
        `}
      </style>

      <div className="h-screen w-screen overflow-hidden flex flex-col">
        <div id="header" className="z-10 bg-white">
          <Header links={navLinks} />
        </div>
      </div>


      <section id="digitalPlans" className="bg-gray-50 dark:bg-gray-900">
        <div className="max-w-screen-xl px-4 py-32 mx-auto lg:py-8 lg:px-6 text-center">
          <div className="mx-auto text-center flex flex-col items-center">
            <div className="flex items-center justify-center gap-4 mb-4">
              <a href="https://www.mydatapulse.co.uk/network" target="_blank" rel="noreferrer">
                {/* <img
                  src="/icons/qr_network.png"
                  alt="Digital Connect Left"
                  className="h-20 object-contain hover:bg-blue-300"
                /> */}
              </a>
              <div>
                <h2 className="text-5xl font-extrabold tracking-tight text-gray-900">
                  The Digital Connect<span className="text-title-purple font-semibold text-xl"> by DataPulse AI</span><br/>
                  <span className="text-blue-600 font-extrabold text-3xl">Scan. Connect. Convert.</span>
                </h2>
                <p className="mb-5 font-light text-gray-500 sm:text-xl">
                  Empower your team with a digital identity built for the future of business.
                  Effortless intros. Smarter networking. Made for the moment.
                </p>
              </div>

              <a href="https://www.mydatapulse.co.uk/network" target="_blank" rel="noreferrer">
                {/* <img
                src="/icons/qr_network.png"
                alt="Digital Connect Right"
                className="h-20 object-contain hover:bg-blue-300"
                /> */}
              </a>
            </div>

          </div>

          <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
            {/* Basic Plan */}
            <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border rounded-lg shadow border-purple-700 hover:bg-purple-100 xl:p-8">
              <h3 className="mb-4 text-2xl font-semibold group-title-purple">Linear (Essential)</h3>
                <div className="text-3xl font-bold">
                <span className="text-title-purple">£12.50</span><br/>
                <span className="text-sm font-normal text-gray-600">per month billed annually</span>
              </div>
              <p className="text-sm text-gray-500 mb-6">or £15 per month billed monthly<br/>(save £30 per employee)</p>
              <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                <li>🔗 <strong>Links:</strong> Up to 3 + Company Website</li>
                <li>📋 <strong>Includes:</strong> Calendly, LinkedIn, WhatsApp, Phone, SMS, 1 Document Link, Company Website, Email</li>
                <li>👤 <strong>Personalisation:</strong> Prospect Name</li>
                <li>🖼️ <strong>Formats:</strong> Flowline</li>
                <li>🌐 <strong>Domain:</strong> id.mydatapulse.co.uk</li>
                <li>🔑 <strong>Admin Access:</strong> 1</li>
                <li>👥 <strong>Min Users:</strong> 1</li>
                <li>🛠️ <strong>Initial Build Fee:</strong> £500<sup>*</sup></li>
                <li>🏢 <strong>Branding:</strong> The Digital Connect by DataPulse AI logo</li>
              </ul>
              {/* <a href="/" className="button-primary w-full mt-auto">Get Started</a> */}
            </div>

            {/* Intermediate Plan */}
            <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border border-purple-700 rounded-lg shadow-xl hover:bg-purple-100 xl:p-8">
              {/* <div className="popular-badge text-left">Popular</div> */}
              <h3 className="mb-4 text-2xl font-semibold group-title-purple">Exponential (Pro)</h3>
                <div className="text-3xl font-bold">
                  <span className="text-title-purple">£20</span><br/>
                  <span className="text-sm font-normal text-gray-600">per month billed annually</span>
              </div>
              <p className="text-sm text-gray-500 mb-6">or £25 per month billed monthly<br/>(save £60 per employee)</p>
              <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                <li>🔗 <strong>Links:</strong> Up to 5 + Company Website</li>
                <li>📋 <strong>Includes:</strong> All Linear features <br/>+ Photo & Bio, Downloadable Contact Card, Spotify, 3 Document Links, Personal Website</li>
                <li>👤 <strong>Personalisation:</strong> Prospect Name</li>
                <li>🖼️ <strong>Formats:</strong> Flowline, Spotlight</li>
                <li>🌐 <strong>Domain:</strong> id.mydatapulse.co.uk</li>
                <li>🔑 <strong>Admin Access:</strong> Up to 3</li>
                <li>👥 <strong>Min Users:</strong> 5</li>
                <li>🛠️ <strong>Initial Build Fee:</strong> £500<sup>*</sup></li>
                <li>🏢 <strong>Branding:</strong> The Digital Connect by DataPulse AI logo</li>
              </ul>
              {/* <a href="#" className="button-primary w-full mt-auto">Choose Plan</a> */}
            </div>

            {/* Advanced Plan */}
            <div className="group flex flex-col max-w-lg p-6 mx-auto text-center text-gray-900 bg-white border rounded-lg shadow border-purple-700 hover:bg-purple-100 xl:p-8">
              <h3 className="mb-4 text-2xl font-semibold group-title-purple">Quantum (Elite)</h3>
                <div className="text-3xl font-bold">
                  <span className="text-title-purple">£25</span><br/>
                  <span className="text-sm font-normal text-gray-600">per month billed annually</span>
                </div>
              <p className="text-sm text-gray-500 mb-6">or £30 per month billed monthly<br/>(save £60 per employee)</p>
              <ul className="space-y-4 font-light text-gray-500 sm:text-lg text-left dark:text-gray-400">
                <li>🔗 <strong>Links:</strong> Up to 5 + Company Website</li>
                <li>📋 <strong>Includes:</strong> All Exponential features + AI Chatbot with Lead Gen, Introduction or Demo functionality, </li>
                <li>👤 <strong>Personalisation:</strong> Prospect Name & Company</li>
                <li>🖼️ <strong>Formats:</strong> Flowline, Spotlight, Gridlock</li>
                <li>🌐 <strong>Domain:</strong> Custom Company Domain</li>
                <li>🔑 <strong>Admin Access:</strong> Up to 5</li>
                <li>👥 <strong>Min Users:</strong> 25</li>
                <li>🛠️ <strong>Initial Build Fee:</strong> £0<sup>*</sup></li>
                <li>🏢 <strong>Branding:</strong> No DataPulse AI branding</li>
                <li>🔮 <strong>First Access to Future Releases:</strong> Link Analytics, Time on Profile, Location Insights, Follow-up Nudge</li>
              </ul>
              {/* <a href="#" className="button-primary w-full mt-auto">Contact Us</a> */}
            </div>
            </div>
          </div>
          <div className="mt-8">
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
              All pricing is costed on a per user basis. For enterprise teams, custom domains, or advanced features, please contact us directly for bespoke pricing.
            </p>
          <br/>
        </div>
      </section>
      {/* <!-- End block --> */}



    </>
  );
}

export default DigitalConnectPricing;
